import React, { ReactNode } from 'react';
import ContentfulNavigation from './navigation/contentfulNavigation';
import { PageContextTypes } from './templates/types';
import ContentfulFooter from './footer/contentfulFooter';
import { Theme } from '../styles/themes';
import {
  HeaderStateProvider,
} from '../components/header/headerStore';
import ContentfulHero, { ContentfulHeroProps } from './hero/contentfulHero';
import InfoBanner from './infoBanner';
import BackNavigation from '../components/navigation/back-navigation/BackNavigation';
import { HistoryLocation } from '@reach/router';
import BreadCrumbs from '../components/navigation/breadcrumbs/BreadCrumbs';
import { HeroCarousel } from '../components/header/HeroCarousel';

type LayoutProps = {
  children: ReactNode;
  pageProps: PageContextTypes;
  heroCarousel?: ContentfulHeroProps[];
  invertedNavigationTheme?: boolean;
  location: HistoryLocation;
};

const Layout: React.FC<LayoutProps> = ({
  pageProps: { breadcrumbs = [], ...pageProps },
  heroCarousel,
  invertedNavigationTheme = false,
  location,
  children,
}) => {
  return (
    <HeaderStateProvider>
      <ContentfulNavigation
        {...pageProps}
        theme={invertedNavigationTheme ? Theme.PrimaryInverse : Theme.Default}
      />

      {heroCarousel ? (
        <>
          <HeroCarousel heroCarousel={heroCarousel} />
          <InfoBanner />
          {breadcrumbs.length > 1 && <BreadCrumbs links={breadcrumbs} />}
        </>
      ) : (
        <>
          {/*<BackNavigation location={location} breadcrumbs={breadcrumbs} />*/}
          {/*breadcrumbs.length > 1 && <BreadCrumbs links={breadcrumbs} />*/}
          <InfoBanner />
        </>
      )}
      {children}

      <ContentfulFooter />
    </HeaderStateProvider>
  );
};

export default Layout;
